import ReferenceDetails from './reference-details';

export default class ReferenceDetailsDesktop extends ReferenceDetails {
    constructor(...args) {
        super(...args);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/reference-details/reference-details.desktop.js